import { User } from '../interfaces/user';
import { localStorageService } from '../../storage/local-storage.service';
import { intercomService } from '../../support/intercom.service';
import { trackingService } from '../../tracking/tracking.service';
import { GenericKeyValueType } from '../../shared/interfaces/generics';
import { USER_DATA_STORAGE_KEY } from '../../storage/constants';
import { MOCK_USER } from '../mock/user';
import { getTemporaryBasicAuthLocal } from '../../shared/utils/config';

class UserService {
  getUser(): User | undefined {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let userData: GenericKeyValueType<string, any>;

    const userDataString = localStorageService.get(USER_DATA_STORAGE_KEY);

    if (getTemporaryBasicAuthLocal()) {
      return MOCK_USER;
    }

    if (!userDataString) {
      return undefined;
    }

    try {
      userData = JSON.parse(userDataString);
    } catch (e) {
      return undefined;
    }

    if (!userData) {
      return undefined;
    }

    let profileImage = userData.image_url;
    profileImage = !profileImage || profileImage === 'undefined' ? undefined : profileImage;

    return {
      name: userData.display_name,
      email: userData.email,
      profileImage,
      isOwner: userData.is_owner,
      id: userData.id,
      isHidden: userData.is_hidden,
      clusterId: userData.cluster_id,
      tfaEnabled: userData.is_tfa_enabled,
      createdTs: userData.created_ts,
      teamId: userData.team_id,
      emailVerified: userData.email_verified,
      isEmailVerificationBlock: userData.email_verification_block,
      teamName: userData.team_name,
      role: userData.additional_details?.role
    };
  }

  setUser(data: GenericKeyValueType<string, unknown>) {
    localStorageService.set(USER_DATA_STORAGE_KEY, JSON.stringify(data));
  }

  clearUser() {
    localStorageService.remove(USER_DATA_STORAGE_KEY);
    intercomService.reset();
    trackingService.reset();
  }

  updateThirdPartyData() {
    const user = this.getUser();

    if (!user) {
      return;
    }

    if (window.CoralogixRum) {
      window.CoralogixRum.setUserContext({
        user_id: user.id.toString(),
        user_name: user.name,
        user_email: user.email
      });
    }

    intercomService.setCurrentUser(user);
    trackingService.onUserChange(user);
    trackingService.setIdentity(user);
  }
}

export const userService = new UserService();
